<div class="cell auto grid-y cell-block-y blockContent grid-padding-y" *ngIf="study">
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th class="_numberColumn"[i18nKey]="'common.quantity'"></th>
            <th class="_numberColumn"[i18nKey]="'common.price'"></th>
            <th class="_numberColumn"[i18nKey]="'common.studies.total.price.excluding.taxes'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.foodstuff'"></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr *ngFor="let dishSales of study.salesResult.firstCoursesTotalSales | keyvalue">
            <td>
                {{'menu.' + dishSales.key | translate}}
            </td>
            <td class="_number">
                {{dishSales.value | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.menuDecision.firstCourses[dishSales.key].purchasingPriceExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>

            <td class="_number">
                {{study.purchasesCosts.firstCoursesIngredientsPurchaseCosts[dishSales.key] | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr *ngFor="let dishSales of study.salesResult.mainCoursesTotalSales | keyvalue">
            <td>
                {{'menu.' + dishSales.key | translate}}
            </td>
            <td class="_number">
                {{dishSales.value | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.menuDecision.mainCourses[dishSales.key].purchasingPriceExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>

            <td class="_number">
                {{study.purchasesCosts.mainCoursesIngredientsPurchaseCosts[dishSales.key] | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr *ngFor="let dishSales of study.salesResult.dessertsTotalSales | keyvalue">
            <td>
                {{'menu.' + dishSales.key | translate}}
            </td>
            <td class="_number">
                {{dishSales.value | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.menuDecision.desserts[dishSales.key].purchasingPriceExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>

            <td class="_number">
                {{study.purchasesCosts.dessertsIngredientsPurchaseCosts[dishSales.key] | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.foodstuff.total'"></td>
            <td class="_number"></td>
            <td class="_number"></td>
            <td class="_totalColumn _number">
                {{study.purchasesCosts.totalIngredientsPurchaseCost | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.drinks'"></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr *ngFor="let dishSales of study.menuDecision.wines | keyvalue">
            <td>
                {{'menu.' + dishSales.key | translate}}
            </td>
            <td class="_number">
                {{dishSales.value.purchasedNumber | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.menuDecision.wines[dishSales.key].purchasingPriceExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>

            <td class="_number">
                {{study.purchasesCosts.winesBottlesPurchasesCosts[dishSales.key] | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.drinks.total'"></td>
            <td class="_number"></td>
            <td class="_number"></td>
            <td class="_totalColumn _number">
                {{study.purchasesCosts.totalWineBottlesPurchaseCost | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.total'"></td>
            <td class="_number"></td>
            <td class="_number"></td>
            <td class="_totalColumn _number">
                {{study.purchasesCosts.totalWineBottlesPurchaseCost + study.purchasesCosts.totalIngredientsPurchaseCost | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        </tbody>
    </table>
</div>
